import { nodeViewDecorators } from 'ricos-common-plugins/viewer';
import { BreakoutDecorator } from './breakoutDecorator.js';
import { Decorators } from './nodeViewDecorators.js';
import 'react';

const decorators = [
  ...nodeViewDecorators,
  BreakoutDecorator
];

export { decorators, Decorators as default };
//# sourceMappingURL=index.js.map
